import SubHeader from '../../components/Subheader/Subheader'
import ViewUser from '../../components/Users/ViewUser'
import React, {useState, useRef} from 'react'
import { useSelector } from 'react-redux'

const ViewUserPage = () => {
  const { financialYears, authData } = useSelector((state) => state.authData);
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const fyList = financialYears.payload.fy_list;
  const handlePageTrigger = () => {
    fyIdRef.current = localStorage.getItem('globalDateId');
  }
  return (
    <div>
      <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
      <ViewUser></ViewUser>
    </div>
  )
}

export default ViewUserPage